var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7536 13.8377L10.7537 4.68817C10.7536 4.27396 10.4177 3.93825 10.0035 3.93835C9.58931 3.93846 9.25361 4.27432 9.25371 4.68854L9.25357 13.8377L4.87701 9.46117C4.58412 9.16827 4.10924 9.16827 3.81635 9.46117C3.52346 9.75406 3.52346 10.2289 3.81635 10.5218L9.47321 16.1787C9.76611 16.4716 10.241 16.4716 10.5339 16.1787L16.1837 10.5289C16.4766 10.236 16.4766 9.76112 16.1837 9.46823C15.8908 9.17533 15.4159 9.17533 15.123 9.46823L10.7536 13.8377Z",
    fill: "#ff4820"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceDown);
export default __webpack_public_path__ + "static/media/price-down.92d10595.svg";
export { ForwardRef as ReactComponent };